import React from 'react';
import { Modal, ModalBody } from 'carbon-components-react';
import messages from '../../../locales/messages';
import './Landing.scss';
import { segmentsTracking } from 'src/common/lib/tracker';
import { Progress } from './ProgressBar';
import { TileOption } from './TileOption';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';

type LandingProps = {
  handleLaunchModal: (param: string) => void;
  openLanding: boolean;
  setOpenLanding: React.Dispatch<React.SetStateAction<boolean>>;
  setOptionSelected: React.Dispatch<React.SetStateAction<number>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setPathSelected: React.Dispatch<React.SetStateAction<string>>;
};

export const Landing = ({
  handleLaunchModal,
  openLanding,
  setOpenLanding,
  setOptionSelected,
  setStep,
  setPathSelected,
}: LandingProps) => {
  const tile01 = 'images/text--to--speech.svg';
  const tile02 = 'images/social--work--01.svg';
  const tile03 = 'images/intelligence.svg';
  const tile04 = 'images/speech--to--text.svg';
  const tile05 = 'images/machine--learning--03.svg';

  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);

  return (
    <div className="bx--grid">
      <div className="Landing">
        <Modal
          passiveModal={true}
          open={openLanding}
          size={'lg'}
          id="ai-sa-landing"
          onRequestClose={() => {
            segmentsTracking('CTA Clicked', {
              pageTitle: 'AI Solutions Advisor',
              object: 'AI Solutions Advisor page',
              resultValue: 'CTA clicked',
              CTA: 'Form modal closed on the corner',
              location: 'URX Form',
              action: `Form modal closed`,
              field: '',
            });
            setOpenLanding(false);
          }}
        >
          <ModalBody hasForm className="ModalBody">
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <p className="ladingPage_title">
                  {useTranslation('landingPage_title')}
                </p>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-14 bx--col-md-8 bx--col-sm-4">
                <p className="ladingPage_subtitle">
                  {useTranslation('landingPage_sutitle')}
                </p>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <Progress step={0}></Progress>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <p>{useTranslation('ladingPage_subHeading')}</p>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <div className="bx--row landingPage_TileRows">
                  <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-4">
                    <TileOption
                      id="clickabel-tile-01"
                      className="landing_tile01"
                      titleText="landingPage_Tile01_Titletext"
                      bodyText="ladingPage_Tile01_Bodytext"
                      handleLaunchModal={handleLaunchModal}
                      icon={tile01}
                      iconId="Tile01"
                      setSelected={setOptionSelected}
                      optionNumber={1}
                      setStep={setStep}
                      step={1}
                      setPathSelected={setPathSelected}
                    />
                  </div>
                  <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-4">
                    <TileOption
                      id="clickabel-tile-02"
                      className="landing_tile02"
                      titleText="landingPage_Tile02_Titletext"
                      bodyText="ladingPage_Tile02_Bodytext"
                      handleLaunchModal={handleLaunchModal}
                      icon={tile02}
                      iconId="Tile02"
                      setSelected={setOptionSelected}
                      optionNumber={2}
                      setStep={setStep}
                      step={1}
                      setPathSelected={setPathSelected}
                    />
                  </div>
                  <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-4">
                    <TileOption
                      id="clickabel-tile-05"
                      className="landing_tile05"
                      titleText="landingPage_Tile05_Titletext"
                      bodyText="ladingPage_Tile05_Bodytext"
                      handleLaunchModal={handleLaunchModal}
                      icon={tile05}
                      iconId="Tile05"
                      setSelected={setOptionSelected}
                      optionNumber={5}
                      setStep={setStep}
                      step={2}
                      setPathSelected={setPathSelected}
                    />
                  </div>
                </div>
                <div className="bx--row landingPage_TileRows">
                  <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-4">
                    <TileOption
                      id="clickabel-tile-03"
                      className="landing_tile03"
                      titleText="landingPage_Tile03_Titletext"
                      bodyText="ladingPage_Tile03_Bodytext"
                      handleLaunchModal={handleLaunchModal}
                      icon={tile03}
                      iconId="Tile03"
                      setSelected={setOptionSelected}
                      optionNumber={3}
                      setStep={setStep}
                      step={1}
                      setPathSelected={setPathSelected}
                    />
                  </div>
                  <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-4">
                    <TileOption
                      id="clickabel-tile-04"
                      className="landing_tile04"
                      titleText="landingPage_Tile04_Titletext"
                      bodyText="ladingPage_Tile04_Bodytext"
                      handleLaunchModal={handleLaunchModal}
                      icon={tile04}
                      iconId="Tile04"
                      setSelected={setOptionSelected}
                      optionNumber={4}
                      setStep={setStep}
                      step={1}
                      setPathSelected={setPathSelected}
                    />
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};
